import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import InputMask from "react-input-mask";
import "./InputMask.scss";

const createInitialState = (numberOfFields) => {
  // Handle negative values and zero by setting minimum fields to 1
  if (numberOfFields <= 0) {
    numberOfFields = 1;
  }
  // Limit the maximum number of fields to 5
  const limit = Math.min(numberOfFields, 5);

  const initialState = {};
  for (let i = 1; i <= limit; i++) {
    initialState[`I${i}`] = "";
  }
  return initialState;
};

function CustomInputMask({
  label,
  name,
  value,
  handleInputMaskChange,
  inputBoxNumber,
  inputDigitLimit,
  touched,
  error,
  modalform,
  className,
}) {
  const [inputMaskValues, setInputMaskValues] = useState(() => createInitialState(inputBoxNumber));
  // const [loadLabel, setLoadLabel] = useState(false);
  const mask = "9".repeat(inputDigitLimit);

  useEffect(() => {
    if (name.includes("Dimension") && value) {
      const parts = value.split(/\s*x\s*/i);
      const newValues = parts.reduce((acc, part, index) => {
        const key = `I${index + 1}`;
        acc[key] = part || "";
        return acc;
      }, {});

      setInputMaskValues(newValues);
    }
  }, [value]);

  // useEffect(() => {
  //   setLoadLabel(label === "Material Dimension(L×W×H)");
  // }, [label]);

  const handleInputChange = (dimension, value) => {
    const newValues = { ...inputMaskValues, [dimension]: value };
    setInputMaskValues(newValues);

    const result = Object.values(newValues).join("x");

    handleInputMaskChange({
      target: {
        name: name,
        value: result.trim(),
      },
    });
  };
  console.log(inputMaskValues, label, "labellabel");
  if (name.includes("Dimension")) {
    return (
      <>
        <label className="text-dimetion-area">{label}</label>
        <div className="Box_Dimension">
          {inputMaskValues &&
            Object.keys(inputMaskValues).map((key, index, array) => (
              <React.Fragment key={key}>
                <InputMask
                  mask={mask}
                  maskChar={null}
                  value={inputMaskValues[key]}
                  onChange={(e) => handleInputChange(key, e.target.value)} // Passing the key dynamically
                  className="form__field"
                />
                {/* Only render RxCross2 if it's not the last element */}
                {index !== array.length - 1 && <RxCross2 className="cross-icon" />}
              </React.Fragment>
            ))}
        </div>
      </>
    );
  }

  return (
    <div className={modalform ? "form__group field" : ""}>
      <InputMask
        mask={modalform && name === "Pan_Number" ? "*************" : undefined}
        value={value || ""}
        onChange={(e) =>
          handleInputMaskChange({
            target: {
              name: name,
              value: e.target.value,
            },
          })
        }
        name={name}
        className={
          modalform
            ? `form__field input_mask ${className} ${touched && error ? "error_input" : ""} ${
                name === "Pan_Number" ? "TextUpper" : ""
              } no-spinners`
            : `${className} no-spinners `
        }
      />
      <label
        className={`${touched && error ? "error_label textAreaLabel" : "form__label textAreaLabel"} top_margin`}
        style={{ marginTop: "1px" }}
      >
        {label}
      </label>
    </div>
  );
}

export default CustomInputMask;
